export default function HowToVideo() {
  const steps = [
    {
      number: '01',
      title: 'お水のみで歯磨き',
      desc: '歯磨き粉を使わず、お水だけで歯をきれいに磨いてください。歯磨き粉の成分がホワイトニング効果を妨げる場合があります。',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/6c9b0d05c2fc035d979baaa270010810.png',
      color: 'bg-[#E3F2FD]',
      iconColor: 'text-[#2C5AA0]',
      badgeColor: 'bg-[#2C5AA0]',
    },
    {
      number: '02',
      title: '歯の水分を拭き取る',
      desc: 'ティッシュや綿棒などで歯の表面の水分をしっかり拭き取ってください。水分が残っているとシートが密着しにくくなります。',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/48fc10d668eaa48654766d685d9e75f2.jpeg',
      color: 'bg-[#E0F7FA]',
      iconColor: 'text-[#00838F]',
      badgeColor: 'bg-[#00838F]',
    },
    {
      number: '03',
      title: 'ホワイトニングシートを貼る',
      desc: '上下の歯にシートをしっかり密着させます。歯と歯の間は爪でしっかりと押し込み、均一に貼り付けてください。',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/1aacb1a85ddd55e448046fae0960bb3d.png',
      color: 'bg-[#E8F5E9]',
      iconColor: 'text-[#2E7D32]',
      badgeColor: 'bg-[#2E7D32]',
    },
    {
      number: '04',
      title: '30分待つ',
      desc: 'シートを貼ったまま30分間そのままお待ちください。その間は飲食をお控えください。',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/6872795d9f7074e6e3221622861cfe7a.png',
      color: 'bg-[#FFF3E0]',
      iconColor: 'text-[#E65100]',
      badgeColor: 'bg-[#E65100]',
    },
    {
      number: '05',
      title: 'ホワイトニングシートを剥がす',
      desc: '30分経ったら、シートをゆっくりと丁寧に剥がしてください。口の中に残った成分は飲み込まず、すすいでください。',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/95594f1709633334b57cc2fbd4bdb423.jpeg',
      color: 'bg-[#FCE4EC]',
      iconColor: 'text-[#AD1457]',
      badgeColor: 'bg-[#AD1457]',
    },
    {
      number: '06',
      title: '歯磨き粉で仕上げ磨き',
      desc: 'シートを外した後、歯磨き粉を使ってしっかり仕上げ磨きをしてください。ホワイトニング効果を定着させます。',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/d7937eaf1d7018630c69b4964a20e329.jpeg',
      color: 'bg-[#F3E5F5]',
      iconColor: 'text-[#6A1B9A]',
      badgeColor: 'bg-[#6A1B9A]',
    },
  ];

  return (
    <section id="how-to-video" className="py-20 bg-[#FAFBFF]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-[#E3F2FD] text-[#2C5AA0] text-xs font-bold rounded-full tracking-widest mb-4">HOW TO USE</span>
          <h2 className="text-4xl font-bold text-gray-900 mb-3">ホワイトニングシートの使い方</h2>
          <p className="text-base text-gray-500">6ステップで簡単。週1～2日取り入れてください。</p>
        </div>

        <div className="flex flex-col gap-8">
          {steps.map((step, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 flex flex-col md:flex-row">
              <div className="relative w-full md:w-72 h-48 shrink-0 overflow-hidden">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute top-4 left-4 ${step.badgeColor} text-white text-xs font-bold px-3 py-1.5 rounded-full shadow`}>
                  STEP {step.number}
                </div>
              </div>
              <div className="p-6 md:p-8 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-9 h-9 flex items-center justify-center ${step.color} rounded-xl shrink-0`}>
                    <span className={`text-sm font-black ${step.iconColor}`}>{step.number}</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">{step.title}</h3>
                </div>
                <p className="text-sm text-gray-500 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* LINE Button */}
        <div className="flex justify-center mt-12">
          <a
            href="https://lin.ee/voFYYoK"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3 bg-[#00C853] text-white text-base font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-xl"></i>
            公式LINEで無料相談・ご予約はこちら
          </a>
        </div>
      </div>
    </section>
  );
}
